import React from "react";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import Modal, {
  ModalText,
  ModalTitle,
  OutsideClickModes,
} from "src/app/components/Modal/Modal";
import { ReactComponent as InfoIcon } from "src/images/info-circle-blue-empty.svg";

import "./ChangeWillAffectManyRowsModal.scss";

interface Props {
  onClose: () => void;
  fieldName: string;
  rowsNumber: number;
  onConfirmClick: () => void;
  onCancelClick: () => void;
}

export const ChangeWillAffectManyRowsModal = (props: Props) => {
  const { onClose, fieldName, rowsNumber, onConfirmClick, onCancelClick } =
    props;

  return (
    <Modal
      className="change-will-affect-many-rows-modal"
      onClose={onClose}
      displayCancelButton
      closeButtonText={
        <IDHFormattedMessage id="ws_cancel" defaultMessage="Cancel" />
      }
      onCancelClick={onCancelClick}
      variant="small"
      confirmButtonText={
        <IDHFormattedMessage id="ws_confirm" defaultMessage="Confirm" />
      }
      onConfirmClick={onConfirmClick}
      outsideClick={OutsideClickModes.Allow}
    >
      <ModalTitle icon={<InfoIcon />}>Info</ModalTitle>
      <ModalText>
        <IDHFormattedMessage
          id="ws_the_value_of"
          defaultMessage="The value of"
        />
        &nbsp;
        {fieldName}
        &nbsp;
        <IDHFormattedMessage
          id="ws_will_be_updated_for"
          defaultMessage="will be updated for"
        />
        :
        <span className="change-will-affect-many-rows-modal__black-text">
          {rowsNumber}
          &nbsp;
          <IDHFormattedMessage id="ws_rows" defaultMessage="rows" />
        </span>
        <IDHFormattedMessage
          id="ws_this_action_cannot_be_undone"
          defaultMessage="This action cannot be undone."
        />
      </ModalText>
    </Modal>
  );
};
